
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

interface RequireAdminProps {
  children: React.ReactNode;
}

const RequireAdmin = ({ children }: RequireAdminProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        if (!user) {
          navigate("/admin/login", { 
            state: { from: location.pathname }
          });
          return;
        }

        const { data, error } = await supabase
          .rpc('is_admin_secure', { input_user_id: user.id });

        if (error) {
          console.error('Error checking admin status:', error);
          navigate("/admin/login");
          return;
        }

        setIsAdmin(!!data);
        if (!data) {
          navigate("/admin/login");
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        navigate("/admin/login");
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, [user, navigate, location]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return isAdmin ? <>{children}</> : null;
};

export default RequireAdmin;
